import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import IntroSvg from "../svg/RRRBlock"
import StripesLeft from "../../images/stripes-left.svg"
import StripesRight from "../../images/stripes-right.svg"
import gsap, { TimelineMax, TweenMax } from "gsap"
import useWindowDimensions from "../useWindowDimensions"

const IndexPage = ({ headerOffset,setContext, appWidth }) => {
    const { height, width } = useWindowDimensions();
    // console.log(height, width);
    let mobileChecker = width < 642 || (height < 600 && width < 642) || ((height / width < .7) && height < 600);

    const handleComplete = () => {
        if(!mobileChecker) {
            setContext({slideIndex:0, path:'/welcome'});
            navigate('/welcome');
        } else {
            setContext({slideIndex:0, path:'/mobile'});
            navigate('/mobile');
        }
    }

    useEffect(()=>{
        let tl = new TimelineMax();
        tl.eventCallback("onComplete", handleComplete);
        const wrap = document.querySelector('.animation-wrap');
        const svg = document.querySelector('.intro-svg');
        const flect0 = document.querySelectorAll('.flect')[0];
        const flect1 = document.querySelectorAll('.flect')[1];
        const focus0 = document.querySelectorAll('.focus')[0];
        const focus1 = document.querySelectorAll('.focus')[1];
        const fine0 = document.querySelectorAll('.fine')[0];
        const fine1 = document.querySelectorAll('.fine')[1];
        const stripesLeft = document.querySelector('.stripes-left');
        const stripesRight = document.querySelector('.stripes-right');

        tl.set(wrap, {opacity: '1'})
        .from(stripesLeft, .75, {opacity: '0', y: '-15px'})
        .from(stripesRight, .75, {opacity: '0', y: '15px'}, "-=.75")
        .from(flect0, .55, {x: -1000, ease: 'Power4.easeOut'}, "-=.25")
        .from(flect1, .55, {y: 1000, ease: 'Power4.easeOut'}, "-=.4")
        .from(focus0, .55, {x: -1000, ease: 'Power4.easeOut'}, "-=.15")
        .from(focus1, .55, {x: 1000, ease: 'Power4.easeOut'}, "-=.4")
        .from(fine0, .55, {x: -1000, ease: 'Power4.easeOut'}, "-=.15")
        .from(fine1, .55, {y: -1000, ease: 'Power4.easeOut'}, "-=.4")
        .to(svg, 1, {scale: 15, opacity: 0}, "+=2")
        .to(stripesRight, 1, {opacity: 0}, "-=1")
        .to(stripesLeft, 1, {opacity: 0}, "-=1")
    },[]); 

    return (
        <div className="animation-wrap">
            <img className="stripes stripes-left" src={StripesLeft} />
            <IntroSvg />
            <img className="stripes stripes-right" src={StripesRight} />
        </div> 
    )
}

export default IndexPage
